module.exports = __webpack_public_path__ + "img/T6.70913aaa.png";